import settings from '@/settings'

const criarTaxa = (headers, data) => {
  return fetch(`${settings.apetrusApi}/checktudo/`, {
    method: 'POST',
    mode: 'cors',
    headers: headers,
    body: JSON.stringify(data)
  })
}

const atualizarTaxa = (headers, data) => {
  return fetch(`${settings.apetrusApi}/checktudo/1/`, {
    method: 'PUT',
    mode: 'cors',
    headers: headers,
    body: JSON.stringify(data)
  })
}

const listarTaxas = (headers) => {
  return fetch(`${settings.apetrusApi}/checktudo/`, {
    method: 'GET',
    mode: 'cors',
    headers: headers
  })
}

export default {
  criarTaxa,
  atualizarTaxa,
  listarTaxas
}
